/* ==========================================================================
   ASCEND — deferred product grids

   The one-page homepage carries ~80 product cards. Rendering them all in the
   initial document made the DOM and first layout on a throttled phone the
   single biggest cost on the page. Each featured-products section therefore
   ships its cards inside an inert <template data-fp-cards>: the browser parses
   the HTML but builds no layout, fetches no images and runs no style work for
   it. This script moves a grid's cards into the live DOM when that grid comes
   within ~1.5 screens of the viewport, so scrolling never meets an empty grid,
   while first render only pays for what is actually on screen.

   Markup is identical before and after — the cards are the same nodes the
   server rendered, so nothing about the layout changes. Grids already inside
   two viewport heights on load are materialised immediately.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ascendLazyGrid) return;
  window.__ascendLazyGrid = true;

  function materialise(grid) {
    var tpl = grid.querySelector('template[data-fp-cards]');
    if (!tpl) return;
    grid.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    grid.classList.remove('grid--pending');
    grid.removeAttribute('data-fp-lazy');
    grid.dispatchEvent(new CustomEvent('fp:rendered', { bubbles: true }));
  }

  function init() {
    var grids = Array.prototype.slice.call(document.querySelectorAll('[data-fp-lazy]'));
    if (!grids.length) return;

    /* Anything already near the top of the page renders now. */
    var eager = window.innerHeight * 2;
    grids = grids.filter(function (g) {
      if (g.getBoundingClientRect().top < eager) { materialise(g); return false; }
      return true;
    });
    if (!grids.length) return;

    if (!('IntersectionObserver' in window)) { grids.forEach(materialise); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); materialise(en.target); }
      });
    }, { rootMargin: '1500px 0px' });
    grids.forEach(function (g) { io.observe(g); });

    /* Anchor links (/#metabolic) into a not-yet-rendered grid: render on hash
       change so the jump lands on real content, not a placeholder. */
    function onHash() {
      var id = location.hash.slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      var g = target.querySelector('[data-fp-lazy]');
      if (g) { io.unobserve(g); materialise(g); }
    }
    window.addEventListener('hashchange', onHash);
    onHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Theme editor re-renders a section: pick up its new template. */
  document.addEventListener('shopify:section:load', function () { window.__ascendLazyGrid = false; window.__ascendLazyGrid = true; init(); });
})();
